export const HbbTVExit = () => {
  try {
    interface HbbTVAppManager extends HTMLElement {
      getOwnerApplication: (document: Document) => unknown;
    }
    interface HbbTVOwnerApplication {
      destroyApplication: () => void;
    }
    const appManager: HbbTVAppManager = document.getElementById(
      'appmgr'
    ) as HbbTVAppManager;

    const app = appManager.getOwnerApplication(
      document
    ) as HbbTVOwnerApplication;
    app.destroyApplication();
  } catch (e) {
    const message = e instanceof Error ? e.message : e;

    window.elasticApm.captureError(new Error(`Exit: ${message}`));
    throw e;
  }
};
